import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../../store/hooks";
import type { OpenTable } from "../../../../../api/reservations";
import type { SeatOption } from "./seatOptions";

/**
 * ЕДИНСТВЕНОТО място с текстовете на въпроса „къде да настаним" — картите
 * „Ще се отвори / Отворена" се строят по един шаблон за
 * всеки случай (нова моя маса, моя сметка, чужда сметка).
 */
export const useSeatChoiceText = () => {
  const { t } = useTranslation();
  const myName = useAppSelector((state) => state.auth.names);
  const waiterOf = (bill: OpenTable) => bill.waiterName ?? t("reservations.seatPicker.unknownWaiter");

  /**
   * Картата на целта: етикет („Ще се отвори"), маса, чия е. `owner` — на кого
   * се отваря новата маса (при „Отделна…" — сервитьорът на избраната сметка);
   * без него — на мен.
   */
  const target = (option: SeatOption, owner?: string | null) =>
    option.kind === "new"
      ? {
          label: t("seatReservation.choice.opens"),
          title: t("seatReservation.choice.newTable", { table: option.table }),
          waiter: t("seatReservation.choice.onWaiter", { waiter: owner ?? myName ?? "" }),
        }
      : {
          label: t("seatReservation.choice.open"),
          title: t("seatReservation.tables", { count: 1, tables: option.bill.tableName }),
          waiter: t("seatReservation.choice.onWaiter", { waiter: waiterOf(option.bill) }),
        };

  return { target };
};
